export default __webpack_public_path__ + "static/media/VendorManagement.75361972.svg";